import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WallFolder, CreateWallFolderDto } from 'types';

export const createFolder = (
  data: CreateWallFolderDto
): Promise<WallFolder> => {
  return axios.post('/api/folders', data);
};

type UseCreateFolderOptions = {
  config?: MutationConfig<typeof createFolder>;
};

export const useCreateFolder = ({ config }: UseCreateFolderOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousFolders) {
        queryClient.setQueryData(['folders'], context.previousFolders);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders']);
    },
    ...config,
    mutationFn: createFolder,
  });
};
